import script from "./SmsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsScreen.vue?vue&type=script&setup=true&lang=js"

import "./SmsScreen.vue?vue&type=style&index=0&id=5f7bf491&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7bf491"]])

export default __exports__